import { MachineType } from './machine-type.interface';
import { Interactivity } from './interactivity.enum';

export enum PartnerType {
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
}

export interface Brand {
  id: number;
  name: string;
  logo: string;
  models: Model[];
  websiteUrl: string;
  partnership: PartnerType;
}

export interface Model {
  id: number;
  name: string;
  machineType: MachineType;
  interactivity: Interactivity;
  bluetoothCompatibility: {
    ios: boolean;
    android: boolean;
  };
  antPlusCompatibility: {
    ios: boolean;
    android: boolean;
  };
  opticalSensorCompatibility: {
    ios: boolean;
    android: boolean;
  };
  embeddedCompatibility: boolean;
  isIos: boolean;
  isAndroid: boolean;
}
